"use client";

import React from "react";
import { useRouter } from "next/navigation";

import CustomizationForm from "@/interfaces/customization-form.interface";

interface ActionCellProps {
  form: CustomizationForm;
  onClone: (formId: string) => void;
  onDelete: (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    form: CustomizationForm,
  ) => void;
  onShare?: (form: CustomizationForm) => void;
}

const ActionCell: React.FC<ActionCellProps> = ({ form, onClone, onDelete, onShare }) => {
  const router = useRouter();

  const handleEditClick = () => {
    router.push(`/customization-forms/${form._id}`);
  };

  return (
    <div className="relative flex items-center justify-end gap-1">
      {onShare && (
        <span
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded p-1 transition-all hover:bg-gray-300"
          onClick={(e) => {
            e.stopPropagation();
            onShare(form);
          }}
        >
          <i
            className="pi pi-share-alt text-purple-600"
            style={{ fontSize: "1.2rem" }}
          />
        </span>
      )}
      <span
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded p-1 transition-all hover:bg-gray-300"
        onClick={(e) => {
          e.stopPropagation();
          onClone(form._id);
        }}
      >
        <i
          className="pi pi-copy text-blue-600"
          style={{ fontSize: "1.2rem" }}
        />
      </span>

      <span
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded p-1 transition-all hover:bg-gray-300"
        onClick={handleEditClick}
      >
        <i
          className="pi pi-pen-to-square text-green-600"
          style={{ fontSize: "1.2rem" }}
        />
      </span>

      <span
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded p-1 transition-all hover:bg-gray-300"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(e, form);
        }}
      >
        <i
          className="pi pi-trash text-red-600"
          style={{ fontSize: "1.2rem" }}
        />
      </span>
    </div>
  );
};

export default ActionCell;
